const BASE_URL = window.origin; //'https://llmwebsite.interplay.iterate.ai';

function getPayload(payload) {
    return {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
    };
}

export function getResponse(question) {
    const payload = {
        my_prompt: question
    };

  return fetch(
    "https://appcoder.interplay.iterate.ai/predict_new",
    getPayload(payload)
  );
}
